import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { StatusContext } from '../../utility/context/StatusContext';
import { InputFileGroup } from './InputFileGroup';
import { text } from '@fortawesome/fontawesome-svg-core';

export const FormDocumention = (props) => {
  const { finishOwnerShip } = props;
  const [activeIndex, setActiveIndex] = useContext(StatusContext);
  return (
    <>
      <Card>
        <CardBody className="row">
          <h3 style={{ fontWeight: 'bold' }}>Adjuntar documentación</h3>
          <p style={{ fontSize: '13px' }}>Inserta los siguientes documentos:</p>
          <div className="row" style={{ textAlign: 'center' }}>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup
                name={'buyer_dni_doc_1'}
                title="DNI Comprado (Parte delantera)"
              />
            </div>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup
                name={'buyer_dni_doc_2'}
                title="DNI Comprado (Parte trasera)"
              />
            </div>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup
                name={'seller_dni_doc_1'}
                title="DNI Vendedor (Parte delantera)"
              />
            </div>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup
                name={'seller_dni_doc_2'}
                title="DNI Vendedor (Parte trasera)"
              />
            </div>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup
                name={'vehicle_doc'}
                title="Documentación del vehiculo"
              />
            </div>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup
                name={'circulation_doc'}
                title="Documentacion de circulación"
              />
            </div>
            <div
              className="col-12 col-xs-12 col-md-6 col-lg-6"
              style={{ marginBottom: '23px' }}
            >
              <InputFileGroup name={'contract_doc'} title="Contrato" />
            </div>
          </div>
        </CardBody>
      </Card>
      <div className="row">
        <div className="col-6" style={{ textAlign: 'left' }}>
          <Button
            onClick={() => setActiveIndex(activeIndex - 1)}
            color="primary"
          >
            Atras{' '}
            <FontAwesomeIcon
              style={{ marginLeft: '3px' }}
              icon={faArrowLeft}
              size={'1x'}
            />
          </Button>
        </div>
        <div className="col-6" style={{ textAlign: 'right' }}>
          <Button
            onClick={async () => {
              await finishOwnerShip();
              setActiveIndex(activeIndex + 1);
            }}
            color="primary"
          >
            Siguiente{' '}
            <FontAwesomeIcon
              style={{ marginLeft: '3px' }}
              icon={faArrowRight}
              size={'1x'}
            />
          </Button>
        </div>
      </div>
    </>
  );
};
